import { SVGProps } from 'react';

const MousePointer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.586 12.586 19 19M3.688 3.037a.497.497 0 0 0-.651.651l6.5 16a.501.501 0 0 0 .947-.063l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z"
    />
  </svg>
);
export default MousePointer;
